/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Calendar_Need_StartInputs */

const cs_calendar_need_start = /** @type {(inputs: Calendar_Need_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nejdříve nastavte začátek`)
};

const en_calendar_need_start = /** @type {(inputs: Calendar_Need_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Set a start date/time first`)
};

/**
* | output |
* | --- |
* | "Set a start date/time first" |
*
* @param {Calendar_Need_StartInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const calendar_need_start = /** @type {((inputs?: Calendar_Need_StartInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Calendar_Need_StartInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_calendar_need_start(inputs)
	return cs_calendar_need_start(inputs)
});